import { FC } from 'react';
import { CreditCard } from '@mui/icons-material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Button, Stack } from '@mui/material';

import { LocalizationTypography } from '~components/organisms/localization';

type Props = {
  onAdd: () => void;
  onDelete?: () => void;
  showDelete?: boolean;
};

export const CardActions: FC<Props> = ({
  onAdd,
  onDelete,
  showDelete = false,
}) => {
  return (
    <Stack
      direction="row"
      sx={{
        py: 1.5,
        gap: 2,
      }}
    >
      <Button
        variant="outlined"
        sx={(theme) => ({
          border: `1px solid ${theme.palette.primary.main}`,
          color: theme.palette.primary.main,
          width: 'fit-content',
          borderRadius: '100px',
        })}
        onClick={onAdd}
      >
        <CreditCard sx={{ marginRight: 1 }} />
        <LocalizationTypography
          textId="app.rentalPage.newStepThree.selectPaymentMethod.addNewCard"
          defaultText="Add New Card"
          variant="Poppins/Subheading-sm"
        />
      </Button>

      {showDelete && onDelete && (
        <Button
          variant="outlined"
          color="error"
          sx={{
            width: 'fit-content',
            borderRadius: '100px',
          }}
          onClick={onDelete}
        >
          <DeleteOutlineIcon sx={{ marginRight: 1 }} />
          <LocalizationTypography
            textId="app.rentalPage.newStepThree.selectPaymentMethod.deleteCard"
            defaultText="Delete Card"
            variant="Poppins/Subheading-sm"
          />
        </Button>
      )}
    </Stack>
  );
};
